namespace GeniuzPOS.Member {
    export enum MbPriceFg {
        PresentDiscount = 1,
        MemberPrice = 2,
        SaleDiscount = 3
    }
    Serenity.Decorators.registerEnumType(MbPriceFg, 'GeniuzPOS.Member.MbPriceFg');
}
